module.exports = {"title":"Conclusion","body":"<p>You’re probably getting pretty good at whatever thing we’re explaining\nhere so good job, carry on, here’s some helpful links, and hope you have\na great life.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./docs/conclusion/index.md
// module id = 467
// module chunks = 0